import { supabase } from './supabase';
import { track } from './analytics';

// "Guess who sent this". Recipients (no account) guess a name; the sender sees
// the count for free and the names once unlocked. The paywall is enforced in
// the database (supabase/guesses.sql) — the browser never receives locked names.

export interface SessionGuesses {
  count: number;
  unlocked: boolean;
  guesses: { name: string; times: number }[];
}

export async function submitGuess(testId: string, guess: string): Promise<{ ok: boolean; error?: string }> {
  try {
    const { data, error } = await supabase.rpc('submit_guess', { p_test_id: testId, p_guess: guess });
    if (error) return { ok: false, error: error.message };
    const res = data as { ok?: boolean; id?: number; error?: string } | null;
    if (!res?.ok) return { ok: false, error: res?.error || 'failed' };

    track('guess_submitted', {}, testId);
    // Tell the sender (free). The server only needs the id, announces it once,
    // and holds back repeat alerts for the same session.
    if (res.id) {
      supabase.functions
        .invoke('send-push', { body: { type: 'guess_made', guessId: res.id } })
        .catch(() => {});
    }
    return { ok: true };
  } catch (e: any) {
    return { ok: false, error: e?.message || 'failed' };
  }
}

export async function getSessionGuesses(testId: string): Promise<SessionGuesses | null> {
  try {
    const { data, error } = await supabase.rpc('my_session_guesses', { p_test_id: testId });
    if (error || !data || (data as any).error) return null;
    return data as SessionGuesses;
  } catch {
    return null;
  }
}

export async function getGuessCounts(): Promise<Record<string, number>> {
  try {
    const { data, error } = await supabase.rpc('my_guess_counts');
    if (error || !data) return {};
    return data as Record<string, number>;
  } catch {
    return {};
  }
}
